


















































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import { School, SearchCondition } from '@/modules/admin/school';
import { Owner, SearchCondition as OwnerSearchCondition } from '@/modules/admin/owner';
import { UserTypes } from '@/enums/userTypes';
import { ElForm } from 'element-ui/types/form';
import { FunctionTypes } from '@/enums/functionTypes';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';
import { Reserve } from '@/enums/reserve';

@Component
export default class EnterLeaveList extends Vue {
  private UserTypes = UserTypes;
  private FunctionTypes = FunctionTypes;
  private CollectionAgencyTypes = CollectionAgencyTypes;
  private Reserve = Reserve;

  private isEdit = false;
  private showSearchCondition = true;

  private ownerList = new Array<Owner>();

  private formRule = {
    schoolId: [
      { required: true, message: 'スクールIDを入力してください' },
      {
        pattern: '^[a-zA-Z0-9]+$',
        trigger: 'blur',
        message: '英数字を入力してください',
      },
    ],
    schoolName: [
      { required: true, message: 'スクール名を入力してください' },
    ],
    paymentMailaddress: [
      { required: true, message: '決済通知用メールアドレスを入力してください' },
      {
        pattern: '^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$',
        trigger: 'change',
        message: '正しいメールアドレスを入力してください',
      },
    ],
  };

  private deleteFormRule = {
    checkSchoolName: [
      { required: true, message: '削除するスクール名を入力してください' },
      { validator: this.validateCheckSchoolName, trigger: 'blur' },
    ],
  };

  private validateCheckSchoolName(rule: any, value: string, callback: any) {
    const schoolName = ((this.$refs.schoolDelete as DialogWrapper).form as any).schoolName;
    if (value.replace(/\s+/g, '') === schoolName.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('スクール名が異なります'));
    }
  }

  get userRole(): UserTypes {
    return this.$store.getters['adminAuth/userType'];
  }

  get loading(): boolean {
    return this.$store.state.adminSchool.loading;
  }

  get countAll(): number {
    return this.$store.state.adminSchool.countAll;
  }

  get schoolList(): School[] {
    return this.$store.state.adminSchool.schools;
  }

  get condition(): SearchCondition {
    return this.$store.state.adminSchool.searchCondition;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  private checkCollectionAgencyVisible(availableFunctionTypes: FunctionTypes[]): boolean {
    const reserveIdx = availableFunctionTypes.indexOf(FunctionTypes.Bill);
    return reserveIdx >= 0;
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private loadData() {
    this.$store.dispatch('adminSchool/searchSchools', this.condition);
  }

  private getRowNumber(index: number) {
    return this.condition.perPage * (this.condition.page - 1) + index + 1;
  }

  private ownerSchoolFormatter(owner: Owner) {
    switch (owner.schoolList.length) {
      case 0: return 'スクールなし';
      case 1: return owner.schoolList[0].name;
      default: return `${owner.schoolList[0].name} 他${owner.schoolList.length - 1}件`;
    }
  }

  private messageFunctionChange(form: any) {
    const result = form.availableFunctionTypes.indexOf(FunctionTypes.Message);
    if (result < 0) {
      const reserveIdx = form.availableFunctionTypes.indexOf(FunctionTypes.Reserve);
      if ( reserveIdx >= 0 ) {
        form.availableFunctionTypes.splice(reserveIdx, 1);
      }
    }
  }

  private reserveFunctionChange(form: any) {
    const result = form.availableFunctionTypes.indexOf(FunctionTypes.Reserve);
    if (result >= 0) {
      const messageIdx = form.availableFunctionTypes.indexOf(FunctionTypes.Message);
      if ( messageIdx < 0 ) {
        form.availableFunctionTypes.push(FunctionTypes.Message);
      }
    }
  }

  @Watch('condition.keyWord')
  private onChangeKeyword() {
    this.condition.page = 1;
    this.loadData();
  }

  private onChangePage() {
    this.loadData();
  }

  private onChangeSort( {prop, order}: any ) {
    if (!prop) {
      this.condition.sort = '';
    } else {
      this.condition.sort = `${prop} ${order}`;
    }
    this.loadData();
  }

  private onSchoolPage(row: School) {
    const token = this.$store.state.adminAuth.token;
    const tab = window.open(`/schoolSingleSignOn/${token}/${row.schoolId}/`, 'school') as Window;
    tab.focus();
  }

  private submitForm() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.schoolEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async setOwners() {
    const ownerCondition: OwnerSearchCondition = {
      keyWord: '',
      perPage: 100000,
      page: 1,
      sort: '',
    };

    try {
      const data = await this.$store.dispatch('adminOwner/getUsers', ownerCondition);
      this.ownerList = data.accountList;
    } catch (error) {
      this.ownerList = new Array<Owner>();
    }
  }

  private async onCreate() {
    this.isEdit = false;

    const form: School = {
      schoolId: '',
      schoolName: '',
      ownerId: null,
      ownerName: '',
      note: '',
      paymentMailaddress: '',
      subjectList: [],
      tagList: [],
      tutorCount: 0,
      studentCount: 0,
      availableFunctionbit: 0,
      availableFunctionTypes: [],
      reservableMonths: Reserve.ReservableMonthsDefault,
      cancellationDays: Reserve.CancellationDaysDefault,
      isAutoEntryOrExit: false,
      collectionAgency: CollectionAgencyTypes.None,
    };

    await this.setOwners();

    let result: School;
    try {
      result = await (this.$refs.schoolEdit as DialogWrapper).open({...form}) as School;
    } catch (error) {
      return;
    }

    if (!result.ownerId) {
      result.ownerName = '';
    } else {
      const findOwner = this.ownerList.find((owner) => owner.id === result.ownerId);
      result.ownerName = !findOwner ? '' : `${findOwner.lastName} ${findOwner.firstName}`;
    }

    try {
      await this.$store.dispatch('adminSchool/createSchool', result);
      this.$notify({
        title: 'スクール登録完了',
        message: `「${result.schoolName}」を登録しました。`,
        position: 'bottom-right',
        type: 'success'
      });
    } catch (error) {
      this.$notify.error({
        title: 'スクール登録エラー',
        message: error.message,
        position: 'bottom-right'
      });
      return;
    }
  }

  private async onEdit(row: School) {
    this.isEdit = true;

    let form: School;
    try {
      form = await this.$store.dispatch('adminSchool/getSchool', row.schoolId);
    } catch (error) {
      form = JSON.parse(JSON.stringify(row));
    }

    await this.setOwners();

    let result: School;
    try {
      result = await (this.$refs.schoolEdit as DialogWrapper).open({...form}) as School;
    } catch (error) {
      return;
    }

    if (!result.ownerId) {
      result.ownerName = '';
    } else {
      const findOwner = this.ownerList.find((owner) => owner.id === result.ownerId);
      result.ownerName = !findOwner ? '' : `${findOwner.lastName} ${findOwner.firstName}`;
    }

    try {
      await this.$store.dispatch('adminSchool/editSchool', result);
      this.$notify({
        title: 'スクール変更完了',
        message: `「${row.schoolName}」を変更しました。`,
        position: 'bottom-right',
        type: 'success'
      });
    } catch (error) {
      this.$notify.error({
        title: 'スクール変更エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private submitDeleteForm() {
    (this.$refs.deleteForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.schoolDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async onDelete(row: School) {
    const schoolName = row.schoolName;

    try {
      const form = {
        schoolName,
        checkSchoolName: '',
      };
      await (this.$refs.schoolDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('adminSchool/deleteSchool', row.schoolId);
      this.$notify({
        title: 'スクール削除完了',
        message: `「${schoolName}」を削除しました。`,
        position: 'bottom-right',
        type: 'success'
      });
    } catch (error) {
      this.$notify.error({
        title: 'スクール削除エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }
}

